package com.xtream.composeapp.viewmodel




import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class SelectedStreamTypeViewModel :ViewModel() {


    //2 for movies, 1 for series
    private val _selectedStreamType = MutableStateFlow(2)
    val selectedStreamType = _selectedStreamType.asStateFlow()

    fun setType(type:Int){
        println("Set: $type")
        _selectedStreamType.value=type
    }
    fun emitType(type:Int){
        viewModelScope.launch {
          //  selectedStreamType.emit(type)
        }
    }


}

